// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Create project
 */
export async function ProjectControllerCreate(
  params: Definitions.CreateProjectDto,
): Promise<{
  error: string
  data: Definitions.ProjectWithRelations
}> {
  // /v1/project
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/project`, {
    ..._params,
  })
}

/**
 * Get user project list
 */
export async function ProjectControllerFindAll(
  params: Paths.ProjectControllerFindAll.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectControllerFindAll.Responses
}> {
  // /v1/project
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project`, {
    params: _params,
  })
}

/**
 * Create mini app
 */
export async function ProjectControllerCreateMiniApp(
  params: Definitions.CreateProjectMiniProgramDto,
): Promise<{
  error: string
  data: Paths.ProjectControllerCreateMiniApp.Responses
}> {
  // /v1/project/{appid}/mini-app
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/project/${_params.appid}/mini-app`, {
    ..._params,
  })
}

/**
 * Get all mini app
 */
export async function ProjectControllerFindMiniApp(
  params: Paths.ProjectControllerFindMiniApp.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectControllerFindMiniApp.Responses
}> {
  // /v1/project/{appid}/mini-app
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/mini-app`, {
    params: _params,
  })
}

/**
 * Get create mini app limit state
 */
export async function ProjectControllerCreateAppLimit(
  params: Paths.ProjectControllerCreateAppLimit.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectControllerCreateAppLimit.Responses
}> {
  // /v1/project/{appid}/mini-app/limit
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/mini-app/limit`, {
    params: _params,
  })
}

/**
 * Get an project by appid
 */
export async function ProjectControllerFindOne(
  params: Paths.ProjectControllerFindOne.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectControllerFindOne.Responses
}> {
  // /v1/project/{appid}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}`, {
    params: _params,
  })
}

/**
 * Get appid exists
 */
export async function ProjectControllerFindAppIdExists(
  params: Paths.ProjectControllerFindAppIdExists.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectControllerFindAppIdExists.Responses
}> {
  // /v1/project/{appid}/exists
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/exists`, {
    params: _params,
  })
}

/**
 * Update project name
 */
export async function ProjectControllerUpdateName(
  params: Definitions.UpdateProjectNameDto,
): Promise<{
  error: string
  data: Definitions.Project
}> {
  // /v1/project/{appid}/name
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.patch(`/v1/project/${_params.appid}/name`, {
    ..._params,
  })
}

/**
 * Create project cloud configuration
 */
export async function ProjectCloudControllerCreate(
  params: Definitions.CreateProjectCloudConfigurationDto,
): Promise<{
  error: string
  data: Paths.ProjectCloudControllerCreate.Responses
}> {
  // /v1/project/{appid}/cloud
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/project/${_params.appid}/cloud`, {
    ..._params,
  })
}

/**
 * Get user project cloud configuration
 */
export async function ProjectCloudControllerFindOne(
  params: Paths.ProjectCloudControllerFindOne.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectCloudControllerFindOne.Responses
}> {
  // /v1/project/{appid}/cloud
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/cloud`, {
    params: _params,
  })
}

/**
 * Create project store
 */
export async function ProjectStoreControllerCreate(
  params: Definitions.CreateProjectStoreDto,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerCreate.Responses
}> {
  // /v1/project/{appid}/store
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/project/${_params.appid}/store`, {
    ..._params,
  })
}

/**
 * Get all store by page
 */
export async function ProjectStoreControllerFindByPage(
  params: Paths.ProjectStoreControllerFindByPage.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerFindByPage.Responses
}> {
  // /v1/project/{appid}/store
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/store`, {
    params: _params,
  })
}

/**
 * Update project store
 */
export async function ProjectStoreControllerUpdate(
  params: Definitions.CreateProjectStoreDto,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerUpdate.Responses
}> {
  // /v1/project/{appid}/store/{id}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.put(`/v1/project/${_params.appid}/store/${_params.id}`, {
    ..._params,
  })
}

/**
 * Get store by id
 */
export async function ProjectStoreControllerFindOne(
  params: Paths.ProjectStoreControllerFindOne.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerFindOne.Responses
}> {
  // /v1/project/{appid}/store/{id}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/store/${_params.id}`, {
    params: _params,
  })
}

/**
 * Delete an project
 */
export async function ProjectStoreControllerDelete(
  params: Paths.ProjectStoreControllerDelete.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerDelete.Responses
}> {
  // /v1/project/{appid}/store/{id}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.delete(`/v1/project/${_params.appid}/store/${_params.id}`, {
    ..._params,
  })
}

/**
 * Get all store
 */
export async function ProjectStoreControllerFindAll(
  params: Paths.ProjectStoreControllerFindAll.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerFindAll.Responses
}> {
  // /v1/project/{appid}/store/all
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/store/all`, {
    params: _params,
  })
}

/**
 * Get create store limit state
 */
export async function ProjectStoreControllerCreateStoreLimit(
  params: Paths.ProjectStoreControllerCreateStoreLimit.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProjectStoreControllerCreateStoreLimit.Responses
}> {
  // /v1/project/{appid}/store/limit
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/project/${_params.appid}/store/limit`, {
    params: _params,
  })
}
